import { render, staticRenderFns } from "./ContractsListTable.vue?vue&type=template&id=35d35bc6&scoped=true&"
import script from "./ContractsListTable.vue?vue&type=script&lang=js&"
export * from "./ContractsListTable.vue?vue&type=script&lang=js&"
import style0 from "./ContractsListTable.vue?vue&type=style&index=0&id=35d35bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d35bc6",
  null
  
)

export default component.exports